import { IPromoInfoSchema } from '../../types/promo';
import { TApplicationState } from '../../types/redux';

export const selectPromoInfo = (state: TApplicationState): IPromoInfoSchema | null => {
  return state.promoInfo.promo;
};
